(() => {
  if (window.__mangoalCartRewardsV2) return;
  window.__mangoalCartRewardsV2 = true;

  const base = (window.Shopify?.routes?.root || '/')
    .replace(/\/?$/, '/');

  const drawer = () => document.getElementById('CartDrawer');
  let refreshTimer;
  let requestId = 0;



const NUDGE_KEY = 'mangoal_cart_redpacket_public_v1';
// Quick-edit trigger settings (seconds). Countdown duration is enforced by the Worker.
const REDPACKET_TRIGGER = Object.freeze({
  cumulativeCartSeconds: 10,
  quietSeconds: 1
});
const NUDGE_DWELL_MS = REDPACKET_TRIGGER.cumulativeCartSeconds * 1000;
const NUDGE_QUIET_MS = REDPACKET_TRIGGER.quietSeconds * 1000;
const OFFER_API = 'https://mangoal-v5-return-offer-test.yzc18300718301.workers.dev/redpacket';

let nudgeTimer;
let nudgeCloseTimer;
let countdownTimer;
let nudgeFallback = null;
let nudgePopup = null;
let latestNudgeCart = null;
let claimInProgress = false;
let offerStartInProgress = false;
let serverClockOffset = 0;

function normalizeOfferAmount(value) {
  const raw = String(value ?? '').trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(raw)) return null;
  const amount = Number(raw);
  return Number.isFinite(amount) && amount >= 1 && amount <= 5
    ? amount.toFixed(2)
    : null;
}

function currentOfferLabel() {
  const amount = normalizeOfferAmount(readNudgeState()?.discountAmount);
  if (!amount) return null;
  const dollars = Number(amount);
  return `$${Number.isInteger(dollars) ? dollars.toFixed(0) : amount}`;
}

function syncOfferCopy() {
  const label = currentOfferLabel();
  const popup = getNudgePopup();
  popup.setAttribute('aria-label', label
    ? `MANGOAL ${label} checkout gift`
    : 'MANGOAL checkout gift');
  const amount = popup.querySelector('[data-mg-offer-amount]');
  const buttonLabel = popup.querySelector('[data-mg-offer-button-label]');
  const bannerLabel = drawer()?.querySelector('[data-mg-offer-heading]');
  if (amount) amount.textContent = label || 'Gift';
  if (!claimInProgress && buttonLabel) {
    buttonLabel.textContent = label ? `Apply ${label} & Checkout` : 'Apply gift & Checkout';
  }
  if (bannerLabel) {
    bannerLabel.textContent = label ? `Your ${label} gift is ready` : 'Your checkout gift is ready';
  }
}

function readNudgeState() {
  try {
    return JSON.parse(
      sessionStorage.getItem(NUDGE_KEY) || 'null'
    ) || nudgeFallback;
  } catch {
    return nudgeFallback;
  }
}

function saveNudgeState(state) {
  nudgeFallback = state;
  try {
    sessionStorage.setItem(NUDGE_KEY, JSON.stringify(state));
  } catch {}
}

function resetNudgeState() {
  nudgeFallback = null;
  try {
    sessionStorage.removeItem(NUDGE_KEY);
  } catch {}
}

function accumulateNudgeDwell(state, active, now = Date.now()) {
  const previous = Math.max(0, Number(state.cumulativeDwellMs) || 0);
  const tick = Number(state.dwellTickAt);
  const increment = state.dwellCounting && Number.isFinite(tick) && tick > 0
    ? Math.max(0, now - tick) : 0;
  const total = Math.min(NUDGE_DWELL_MS, previous + increment);
  return {
    ...state,
    cumulativeDwellMs: total,
    dwellCompletedAt: state.dwellCompletedAt || (total >= NUDGE_DWELL_MS ? now : null),
    dwellCounting: active,
    dwellTickAt: active ? now : null
  };
}

function nudgeDrawerOpen() {
  const d = drawer();
  return !!(d && d.open && !d.hidden);
}

function getNudgePopup() {
  if (nudgePopup?.isConnected) return nudgePopup;

  nudgePopup = document.createElement('div');
  nudgePopup.className = 'mg-cart-nudge-modal';
  nudgePopup.hidden = true;
  nudgePopup.setAttribute('role', 'dialog');
  nudgePopup.setAttribute('aria-modal', 'false');
  nudgePopup.setAttribute('aria-label', 'MANGOAL checkout gift');

  nudgePopup.innerHTML = `
    <div class="mg-cart-nudge-modal__card">
      <div class="mg-cart-nudge-modal__top">
        <span class="mg-cart-nudge-modal__eyebrow">MANGOAL <span aria-hidden="true">/</span> CHECKOUT GIFT</span>
        <button type="button" class="mg-cart-nudge-modal__close"
          data-mg-popup-close aria-label="Close offer">×</button>
      </div>
      <div class="mg-cart-nudge-modal__envelope" aria-hidden="true">
        <span class="mg-cart-nudge-modal__back"></span>
        <span class="mg-cart-nudge-modal__flap"></span>
        <span class="mg-cart-nudge-modal__pocket"></span>
        <span class="mg-cart-nudge-modal__seal">M</span>
      </div>
      <strong class="mg-cart-nudge-modal__title">A little something for you.</strong>
      <div class="mg-cart-nudge-modal__offer">
        <strong class="mg-cart-nudge-modal__amount" data-mg-offer-amount>Gift</strong>
        <span class="mg-cart-nudge-modal__offer-label">OFF YOUR ORDER</span>
      </div>
      <p class="mg-cart-nudge-modal__desc">
        Your checkout gift is ready. Use it on this visit before the timer ends.
      </p>
      <div class="mg-cart-nudge-modal__meta">
        <span class="mg-cart-nudge-modal__meta-label">OFFER ENDS IN</span>
        <span class="mg-cart-nudge-modal__timer" data-mg-offer-timer aria-live="off">30:00</span>
        <span class="mg-cart-nudge-modal__meta-tail">ONE USE</span>
      </div>
      <button type="button" class="mg-cart-nudge-modal__cta"
        data-mg-popup-checkout><span data-mg-offer-button-label>Apply gift &amp; Checkout</span> <span aria-hidden="true">→</span></button>
      <p class="mg-cart-nudge-modal__status" data-mg-popup-status role="status" hidden></p>
      <div class="mg-cart-nudge-modal__footnote">One-time checkout gift · Offer applies at checkout</div>
      <button type="button" class="mg-cart-nudge-modal__backlink"
        data-mg-popup-close>Continue shopping</button>
    </div>
  `;

  document.body.appendChild(nudgePopup);

  nudgePopup.addEventListener('click', event => {
    if (event.target.closest('[data-mg-popup-close]')) {
      minimizeNudge();
    }

    if (event.target.closest('[data-mg-popup-checkout]')) {
      claimRedpacket();
    }
  });

  return nudgePopup;
}

function currentOfferRemaining() {
  const expiry = Number(readNudgeState()?.expiresAt);
  return Number.isFinite(expiry) ? Math.max(0, expiry - (Date.now() + serverClockOffset)) : 0;
}

function formatRemaining(milliseconds) {
  const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
  return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
}

function updateCountdown() {
  const state = readNudgeState();
  if (!state?.shown || state.checkedOut || state.expired) return;
  const remaining = currentOfferRemaining();
  const value = formatRemaining(remaining);
  const popupTimer = getNudgePopup().querySelector('[data-mg-offer-timer]');
  const bannerTimer = drawer()?.querySelector('[data-mg-nudge-timer]');
  if (popupTimer) popupTimer.textContent = value;
  if (bannerTimer) bannerTimer.textContent = value;
  if (remaining <= 0) disableNudge('expired');
}

function redpacketPayload() {
  if (!latestNudgeCart?.item_count || latestNudgeCart.currency !== 'USD') return null;
  const sessionToken = readNudgeState()?.sessionToken;
  return {
    currency: latestNudgeCart.currency,
    items: latestNudgeCart.items.map(item => ({ id: item.variant_id, quantity: item.quantity })),
    cartToken: latestNudgeCart.token || '',
    ...(sessionToken ? { sessionToken } : {})
  };
}

async function requestRedpacket(action) {
  const body = redpacketPayload();
  if (!body) throw new Error('Checkout gift is not available for this cart.');
  const response = await fetch(`${OFFER_API}/${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal: AbortSignal.timeout(15000)
  });
  const result = await response.json();
  if (Number.isFinite(Number(result.serverNow))) {
    serverClockOffset = Number(result.serverNow) - Date.now();
  }
  if (!response.ok) {
    const error = new Error(result.state === 'expired'
      ? 'This checkout offer has expired.'
      : 'Offer unavailable right now. Please continue with regular checkout.');
    error.reason = result.state;
    throw error;
  }
  return result;
}

async function startRedpacket() {
  if (offerStartInProgress || !nudgeDrawerOpen() || document.visibilityState !== 'visible') return;
  offerStartInProgress = true;
  clearTimeout(nudgeTimer);
  try {
    const result = await requestRedpacket('start');
    if (result.state !== 'offered' || !Number.isFinite(Number(result.expiresAt)) ||
        Number(result.expiresAt) <= Date.now() + serverClockOffset) {
      disableNudge(result.state === 'expired' ? 'expired' : 'checkedOut');
      return;
    }
    const discountAmount = normalizeOfferAmount(result.discountAmount);
    if (!discountAmount) throw new Error('Checkout gift amount is unavailable.');
    const state = readNudgeState() || {};
    saveNudgeState({ ...state, shown: true, expiresAt: Number(result.expiresAt),
      firstShownAt: Number(result.firstShownAt), sessionToken: String(result.sessionToken || ''),
      discountAmount, minimized: !nudgeDrawerOpen() });
    clearInterval(countdownTimer);
    countdownTimer = setInterval(updateCountdown, 1000);
    const banner = drawer()?.querySelector('[data-mg-nudge]');
    if (banner) banner.hidden = true;
    syncOfferCopy();
    if (nudgeDrawerOpen()) getNudgePopup().hidden = false;
    updateCountdown();
  } catch (error) {
    console.warn('MANGOAL checkout gift:', error.message);
    const state = readNudgeState() || {};
    saveNudgeState({ ...state, retryAfter: Date.now() + 30000 });
    nudgeTimer = setTimeout(() => {
      if (latestNudgeCart) updateNudge(latestNudgeCart);
    }, 30050);
  } finally {
    offerStartInProgress = false;
  }
}

async function claimRedpacket() {
  if (claimInProgress || !latestNudgeCart?.item_count || currentOfferRemaining() <= 0) return;
  const popup = getNudgePopup();
  const button = popup.querySelector('[data-mg-popup-checkout]');
  const buttonLabel = popup.querySelector('[data-mg-offer-button-label]');
  const status = popup.querySelector('[data-mg-popup-status]');
  const offerLabel = currentOfferLabel();
  claimInProgress = true;
  button.disabled = true;
  buttonLabel.textContent = offerLabel
    ? `Applying your ${offerLabel} gift…`
    : 'Applying your gift…';
  status.hidden = true;
  try {
    const result = await requestRedpacket('claim');
    if (result.state !== 'claimed' || !result.code) {
      throw new Error('Offer unavailable right now. Please try regular checkout.');
    }
    disableNudge('checkedOut');
    const discountPath = base + 'discount/' + encodeURIComponent(result.code);
    const redirectPath = base + 'checkout';
    window.location.assign(discountPath + '?redirect=' + encodeURIComponent(redirectPath));
  } catch (error) {
    status.textContent = error.message || 'Unable to claim your offer.';
    status.hidden = false;
    button.disabled = false;
    buttonLabel.textContent = offerLabel
      ? `Apply ${offerLabel} & Checkout`
      : 'Apply gift & Checkout';
  } finally {
    claimInProgress = false;
  }
}

function hideNudge() {
  const banner = drawer()?.querySelector('[data-mg-nudge]');
  if (banner) banner.hidden = true;
  if (nudgePopup) nudgePopup.hidden = true;
}

function disableNudge(reason) {
  const state = readNudgeState() || {
    startedAt: Date.now()
  };

  saveNudgeState({ ...state, [reason]: true });
  clearTimeout(nudgeTimer);
  clearTimeout(nudgeCloseTimer);
  clearInterval(countdownTimer);
  countdownTimer = null;
  hideNudge();
}

function minimizeNudge() {
  clearTimeout(nudgeCloseTimer);

  const state = readNudgeState();
  if (!state || !state.shown ||
      state.dismissed || state.checkedOut || state.expired) return;

  saveNudgeState({ ...state, minimized: true });

  if (nudgePopup) nudgePopup.hidden = true;
  if (latestNudgeCart) updateNudge(latestNudgeCart);
}

function reopenNudge() {
  const state = readNudgeState();
  if (!state?.shown || state.dismissed || state.checkedOut || state.expired ||
      !nudgeDrawerOpen()) return;

  if (currentOfferRemaining() <= 0) {
    disableNudge('expired');
    return;
  }

  saveNudgeState({ ...state, minimized: false });
  const banner = drawer()?.querySelector('[data-mg-nudge]');
  if (banner) banner.hidden = true;
  syncOfferCopy();
  getNudgePopup().hidden = false;
  updateCountdown();
}

function showNudgePopup() {
  const state = readNudgeState();
  if (!state || state.shown ||
      state.dismissed || state.checkedOut || state.expired ||
      !nudgeDrawerOpen() ||
      document.visibilityState !== 'visible') return;
  startRedpacket();
}

function updateNudge(cart) {
  latestNudgeCart = cart;
  clearTimeout(nudgeTimer);

  if (!cart?.item_count) {
    clearTimeout(nudgeCloseTimer);
    resetNudgeState();
    hideNudge();
    return;
  }

  if (cart.currency !== 'USD') {
    hideNudge();
    return;
  }

  let state = readNudgeState();

  if (!state || !Number.isFinite(Number(state.startedAt))) {
    state = {
      startedAt: Date.now(),
      cumulativeDwellMs: 0,
      dwellCompletedAt: null,
      dwellCounting: false,
      dwellTickAt: null,
      lastInteractionAt: Date.now(),
      dismissed: false,
      checkedOut: false,
      shown: false,
      minimized: false
    };
  }

  // Count only foreground shopping time with cart items; drawer opening is NOT the timer start.
  state = accumulateNudgeDwell(state, document.visibilityState === 'visible');
  saveNudgeState(state);

  const banner = drawer()?.querySelector('[data-mg-nudge]');
  const active = nudgeDrawerOpen() &&
    document.visibilityState === 'visible';

  if (state.dismissed || state.checkedOut || state.expired) {
    hideNudge();
    return;
  }

  if (state.shown) {
    if (currentOfferRemaining() <= 0) {
      disableNudge('expired');
      return;
    }
    if (!countdownTimer) countdownTimer = setInterval(updateCountdown, 1000);
    syncOfferCopy();
    if (!active && !state.minimized) {
      minimizeNudge();
      return;
    }
    if (banner) {
      banner.hidden = !(state.minimized && active);
    }
    updateCountdown();
    return;
  }

  if (banner) banner.hidden = true;
  // Stage 1: accumulated foreground shopping time. Stage 2: uninterrupted quiet time.
  const now = Date.now();
  const dwellRemaining = Math.max(0, NUDGE_DWELL_MS - state.cumulativeDwellMs);
  const quietDueAt = state.dwellCompletedAt
    ? Math.max(Number(state.dwellCompletedAt) + NUDGE_QUIET_MS,
      Number(state.lastInteractionAt || 0) + NUDGE_QUIET_MS,
      Number(state.retryAfter) || 0)
    : 0;
  const remaining = state.dwellCompletedAt ? Math.max(0, quietDueAt - now) : dwellRemaining;

  if (active && state.dwellCompletedAt && remaining <= 0) {
    showNudgePopup();
  } else if (document.visibilityState === 'visible' &&
             (dwellRemaining > 0 || (state.dwellCompletedAt && remaining > 0))) {
    nudgeTimer = setTimeout(() => {
      if (latestNudgeCart) updateNudge(latestNudgeCart);
    }, remaining + 50);
  }
}

function bindNudgeInteractions() {
  let wasOpen = nudgeDrawerOpen();

  const recordInteraction = () => {
    if (!latestNudgeCart?.item_count || document.visibilityState !== 'visible') return;
    const state = readNudgeState();
    if (!state || state.shown || state.dismissed || state.checkedOut || state.expired) return;
    const now = Date.now();
    // Throttle high-frequency scroll/wheel events while keeping the quiet window accurate.
    if (now - Number(state.lastInteractionAt || 0) < 150) return;
    saveNudgeState({ ...state, lastInteractionAt: now });
    updateNudge(latestNudgeCart);
  };

  for (const eventType of ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll', 'input']) {
    document.addEventListener(eventType, recordInteraction, { capture: true, passive: true });
  }

  const d = drawer();
  if (d) {
    const observer = new MutationObserver(() => {
      const open = nudgeDrawerOpen();
      if (open === wasOpen) return;

      wasOpen = open;
      if (!open && nudgePopup && !nudgePopup.hidden) {
        minimizeNudge();
      }

      if (latestNudgeCart) updateNudge(latestNudgeCart);
    });

    observer.observe(d, {
      attributes: true,
      attributeFilter: ['hidden', 'open', 'class']
    });
  }

  document.addEventListener('visibilitychange', () => {
    if (latestNudgeCart?.item_count) {
      const state = readNudgeState();
      if (state) {
        // Pause dwell while in another tab, and require fresh quiet time on return.
        saveNudgeState({
          ...accumulateNudgeDwell(state, false),
          lastInteractionAt: Date.now()
        });
      }
    }
    if (latestNudgeCart) updateNudge(latestNudgeCart);
  });

  window.addEventListener('pagehide', () => {
    const state = readNudgeState();
    if (state && latestNudgeCart?.item_count) saveNudgeState(accumulateNudgeDwell(state, false));
  });
}


  function text(parent, selector, value) {
    const element = parent?.querySelector(selector);
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function updateRecommendations(cart) {
    const box = drawer()?.querySelector('[data-mg-upsell]');
    if (!box) return;

    if (!cart.item_count || cart.currency !== 'USD') {
      box.hidden = true;
      return;
    }

    const cartProducts = new Set(
      cart.items.map(item => String(item.product_id))
    );

    const list = box.querySelector('[data-mg-upsell-list]');
    if (!list) return;

    const items = Array.from(
      list.querySelectorAll('[data-mg-upsell-item]')
    );

    const candidates = items.filter(item =>
      !cartProducts.has(item.dataset.productId)
    );

    candidates.sort((a, b) => {
      const pa = Number(a.dataset.price);
      const pb = Number(b.dataset.price);
      return pa - pb;
    });

    
const visible = candidates.slice(0, 3);

// Only change visibility when necessary.
// Do not move cards in the DOM.
items.forEach(item => {
  const rank = visible.indexOf(item);
  const shouldHide = rank === -1;

  if (item.hidden !== shouldHide) {
    item.hidden = shouldHide;
  }

  if (rank !== -1) {
    const order = String(rank);

    if (item.style.order !== order) {
      item.style.order = order;
    }
  }
});

const shouldHideBox = visible.length === 0;

if (box.hidden !== shouldHideBox) {
  box.hidden = shouldHideBox;
}


    text(
      box,
      '[data-mg-upsell-title]',
      'Recommended Products'
    );

    text(
      box,
      '[data-mg-upsell-sub]',
      'Recommended accessories.'
    );
  }

  function render(cart) {
  updateRecommendations(cart);
  updateNudge(cart);
}

  async function loadCart() {
    const id = ++requestId;

    try {
      const response = await fetch(`${base}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();

      if (id === requestId) render(cart);
    } catch (error) {
      console.warn('MANGOAL Rewards:', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(loadCart, 150);
  }

  function updateQuantity(button) {
    const item = button.closest('[data-mg-upsell-item]');
    const output = item?.querySelector('[data-mg-quantity]');
    if (!output) return;

    let quantity = Number(output.textContent) || 1;

    quantity += button.hasAttribute('data-mg-plus') ? 1 : -1;
    quantity = Math.max(1, Math.min(10, quantity));

    output.textContent = String(quantity);
  }

  async function addRecommendedProduct(button) {
    const item = button.closest('[data-mg-upsell-item]');
    if (!item || button.disabled) return;

    const variantId = Number(item.dataset.variantId);
    const quantity = Number(
      item.querySelector('[data-mg-quantity]')?.textContent || 1
    );

    const errorBox = item.querySelector('[data-mg-error]');

    if (!variantId || !Number.isInteger(quantity) || quantity < 1) {
      return;
    }

    button.disabled = true;
    button.textContent = 'Adding...';

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    try {
      const response = await fetch(`${base}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || result.message || 'Unable to add item'
        );
      }

      button.textContent = 'Added!';

      // FoxTheme's cart.js listens for this event,
      // fetches the current cart and rerenders the drawer.
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { open: true }
        })
      );

      scheduleRefresh();
    } catch (error) {
      if (errorBox) {
        errorBox.textContent = error.message || 'Please try again.';
        errorBox.hidden = false;
      }
      button.textContent = 'Try again';
    } finally {
      setTimeout(() => {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = '+ Add';
        }
      }, 900);
    }
  }

  function bindActions() {
    // Event delegation survives Shopify's drawer rerenders.
    document.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('#CartDrawer [data-mg-nudge-open]')) {
        event.preventDefault();
        reopenNudge();
        return;
      }

const nudgeClose = target.closest(
  '#CartDrawer [data-mg-nudge-dismiss]'
);

if (nudgeClose) {
  event.preventDefault();
  disableNudge('dismissed');
  return;
}

const checkoutButton = target.closest(
  '#CartDrawer button[name="checkout"], ' +
  '#CartDrawer a[href*="/checkout"]'
);

if (checkoutButton) {
  disableNudge('checkedOut');
  return;
}


      const qtyButton = target.closest(
        '[data-mg-plus], [data-mg-minus]'
      );

      if (qtyButton && qtyButton.closest('#CartDrawer')) {
        event.preventDefault();
        updateQuantity(qtyButton);
        return;
      }

      const addButton = target.closest('[data-mg-add]');

      if (addButton && addButton.closest('#CartDrawer')) {
        event.preventDefault();
        addRecommendedProduct(addButton);
      }
    });
  }

  
function bindCartEvents() {
  // FoxTheme updates this event when cart contents change.
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart) {
      ++requestId;
      render(event.detail.cart);
    } else {
      scheduleRefresh();
    }
  });

  // Refresh after returning to the page.
  window.addEventListener('pageshow', scheduleRefresh);
}

 function start() {
  bindActions();
  bindCartEvents();
  bindNudgeInteractions();
  loadCart();
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
